module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page section-image",
    attrs: {
      "data-color": "black",
      "data-image": "/assets/img/login-background.jpg"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Welcome")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Hello " + _vm._s(_vm.user) + ". Enter a password and then click the button below to create an account.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.signupSubmit()
      }
    }
  }, [_vm._v("Sign up")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.error))])], 1)])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360bfb6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/signup.vue
// module id = 696
// module chunks = 0